import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import UiLoader from '@/ui/UiLoader/UiLoader';

export default function Qr() {
  const navigate = useNavigate();

  const [ isShowLoader, setIsShowLoader ] = React.useState<boolean>(true);
  const params = new URLSearchParams(window.location.search)
  const quuid = params.get('quuid');

  React.useEffect(() => {
    setIsShowLoader(!!quuid)

    const timeout = setTimeout(() =>{
      if (!!quuid) {
        navigate(`/?quuid=${quuid}`);
      }
    }, 1000)
    return () => window.clearTimeout(timeout);
  }, [quuid, navigate])

  return <div>
    {
      isShowLoader ? <UiLoader /> : 'Параметр quuid не определен'
    }
  </div>;
};